import type { ReactNode } from 'react'

import { EmptyState, Panel } from '../../ui/primitives'

/**
 * Пакетики, боксы и альбомы. Товар связан с коллекцией каталога.
 *
 * Экран-заготовка: разметка и место под данные есть, загрузка из API
 * появится вместе с наполнением каталога.
 */
export function ShopScreen(): ReactNode {
  return (
    <section>
      <h1>Магазин</h1>
      <Panel>
        <EmptyState text="Пока пусто" />
      </Panel>
    </section>
  )
}
